$(document).ready(function () {
  var dra = new theme.Drawers("CartDrawer", "cart");
  // dra.open();
  var length = [];
  var size = [];
  //check all options
  $(".body-template-product-custom-tailored fieldset[data-index='option1']")
    .find(".variant-input")
    .each(function () {
      var Setval = "";
      var getVal = $(this).find("label").text();
      var thiss = this;
      $("select.product-single__variants")
        .find("option")
        .each(function () {
          var OptionTitle = $(this).attr("variant-id");
          var matchVariant = OptionTitle.includes(getVal);
          if (matchVariant == true) {
            var getQuantity = $(this).attr("variant-stock");
            if (getQuantity > 0) {
              Setval = true;
            }
          }
        });
      if (Setval != true) {
        $(this).addClass("disabled-option");
        $(this).find("label").addClass("disabled-new");
        $(this).find("input").attr("disabled", "disabled");
      }
    });
  //disable out of stock variants on selection
  var notfound = [];
  var countPrice = [];
  $(
    ".body-template-product-custom-tailored fieldset[data-index='option1'] .variant-input input"
  ).on("change", function () {
    var Setval = "";
    var getVal = $(this).val();
    notfound = [];

    $("select.product-single__variants")
      .find("option")
      .each(function () {
        var OptionTitle = $(this).attr("variant-id");
        var option2nd = $(this).attr("variant-sec");
        var matchVariant = OptionTitle.includes(getVal);
        //console.log(OptionTitle,option2nd,matchVariant)
        var getlength = $("select.product-single__variants").find(
          "option[variant-id='" +
            OptionTitle +
            "'][variant-sec='" +
            option2nd +
            "']"
        ).length;
        if (matchVariant == true) {
          console.log(matchVariant);
          var getQuantity = $(this).attr("variant-stock");
          //console.log(OptionTitle,option2nd,getQuantity)
          notfound.push(OptionTitle);

          if (getQuantity > 0) {
            Setval = true;
            $(
              "fieldset[data-index='option2'] .variant-input input[value='" +
                option2nd +
                "']"
            )
              .parents(".variant-input")
              .removeClass("disabled-option");
            $(
              "fieldset[data-index='option2'] .variant-input input[value='" +
                option2nd +
                "']"
            )
              .siblings("label")
              .removeClass("disabled-new");
            $(
              "fieldset[data-index='option2'] .variant-input input[value='" +
                option2nd +
                "']"
            ).removeAttr("disabled");
            console.log(option2nd);
            // console.log(getQuantity)
          } else {
            console.log(option2nd);
            // console.log(getQuantity)
            $(
              "fieldset[data-index='option2'] .variant-input input[value='" +
                option2nd +
                "']"
            )
              .parents(".variant-input")
              .addClass("disabled-option");
            $(
              "fieldset[data-index='option2'] .variant-input input[value='" +
                option2nd +
                "']"
            )
              .siblings("label")
              .addClass("disabled-new");
            $(
              "fieldset[data-index='option2'] .variant-input input[value='" +
                option2nd +
                "']"
            ).attr("disabled", "disabled");
          }
        } else {
          console.log(matchVariant);
        }
      });

    if (Setval == true) {
      //$("fieldset .variant-input input[value='"++"']")
    }
    if (
      $(
        ".body-template-product-custom-tailored fieldset[data-index='option2'] .variant-input"
      )
        .find("input:checked")
        .siblings("label")
        .hasClass("disabled-new")
    ) {
      console.log($(this));
      $(this).find("input").prop("checked", false);
      $("fieldset[data-index='option2'] .variant-input")
        .find("input:checked")
        .parents(".variant-input")
        .next(".variant-input")
        .each(function (index) {
          if ($(this).find("label").hasClass("disabled-new")) {
          } else {
            $(this).find("input").trigger("click");
            return false;
          }
        });
      //setTimeout(function(){
      //$(".body-template-product-custom-tailored fieldset[data-index='option2']").find(".variant-input:not(.disabled-option)").first().find("input").trigger("click")
      // }, 500);
    }
    console.log(notfound);
  });

  //created length options
  $(
    ".body-template-product-custom-tailored fieldset[data-index='option1'] .variant-input input"
  ).on("change", function () {
    //$(".selected-text").hide();
    $(".popup-length-option-items").html("");
    countPrice = [];
    $(this)
      .parents(".variant-wrapper.js")
      .find(".proceed-to-cart-btn")
      .attr("disabled", "disabled");
    var Getselected = $(this).val();
    $(this)
      .parents(".variant-input")
      .prevAll(".variant-input")
      .each(function (index) {
        if (index < 2) {
          var get = $(this).find("label").hasClass("disabled-new");
          if (get == true) {
            $(this)
              .parents(".variant-wrapper")
              .find(".get-it-tailored-button")
              .show();
            //$(this).parents(".variant-wrapper").find(".selected-text").show();
          } else {
            $(this)
              .parents(".variant-wrapper")
              .find(".get-it-tailored-button")
              .hide();
            $(this)
              .parents(".variant-wrapper")
              .find(".modaltailored .custom-option-variant")
              .html("");
            $(this).parents(".variant-wrapper").find(".selected-text").hide();
          }
          if ($(this).find("label").hasClass("disabled-new")) {
            $(".popup-length-option-items").append(
              "<div class='custom-option-variant'><input type='radio' id='length-option--" +
                index +
                "' name='length-option' value='" +
                $(this).find("label").text() +
                "'><label for='length-option--" +
                index +
                "'>" +
                $(this).find("label").text() +
                "</label></div>"
            );
          }
        }
      });
    var Selectedval = $("select.product-single__variants option:selected").attr(
      "variant-id"
    );
    $(".popup-size-option-items").html("");
    $(this)
      .parents(".variant-wrapper.js")
      .find(".proceed-to-cart-btn")
      .attr("disabled", "disabled");
    $(
      ".body-template-product-custom-tailored fieldset[data-index='option2'] .variant-input input:checked"
    )
      .parents(".variant-input")
      .prevAll(".variant-input")
      .each(function (index) {
        if (index < 1) {
          var get = $(this).find("label").hasClass("disabled-new");
          if (get == true) {
            $(this)
              .parents(".variant-wrapper")
              .find(".get-it-tailored-button")
              .show();
            //$(this).parents(".variant-wrapper").find(".selected-text").show();
          } else {
            $(this)
              .parents(".variant-wrapper")
              .find(".get-it-tailored-button")
              .hide();
            $(this)
              .parents(".variant-wrapper")
              .find(".modaltailored .custom-option-variant")
              .html("");
            $(this).parents(".variant-wrapper").find(".selected-text").hide();
          }
          if ($(this).find("label").hasClass("disabled-new")) {
            $(".popup-size-option-items").append(
              "<div class='custom-option-variant'><input type='radio' id='size-option--" +
                index +
                "' name='size-option' value='" +
                $(this).find("label").text() +
                "'><label for='size-option--" +
                index +
                "'>" +
                $(this).find("label").text() +
                "</label></div>"
            );
          }
        }
      });
    countPrice.push(
      $("select.product-single__variants")
        .find("option:selected")
        .attr("variant-money")
    );
    $(".popup-options-container").each(function () {
      if ($(this).find("input").is(":checked")) {
        countPrice.push(
          $(this).find(".options-container").attr("tailored-price")
        );
      }
    });
    console.log(countPrice);
    var total = 0;
    countPrice.forEach(function (num) {
      total += parseFloat(num) || 0;
    });
    console.log(total);
    total = parseFloat(total) / 100;
    var newTotal = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    console.log(newTotal);
    var newCurrency = currencyFormat
      .replace("{{amount}}", newTotal)
      .replace("{{amount_with_comma_separator}}", newTotal)
      .replace("{{amount_no_decimals_with_comma_separator}}", newTotal)
      .replace("{{amount_no_decimals}}", newTotal)
      .replace("{{amount_no_decimals_with_space_separator}}", newTotal);
    console.log(newCurrency);
    $("span.product__price").text(newCurrency);
    //$("span.product__price").text(currencyFormat+(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
  });
  //created size options
  $(
    ".body-template-product-custom-tailored fieldset[data-index='option2'] .variant-input input"
  ).on("change", function () {
    //$(".selected-text").hide();
    $(".popup-size-option-items").html("");
    var Getselected = $(this).val();
    countPrice = [];
    //$(this).parents(".variant-input").prevAll(':lt(2)').addClass('highlight');
    $(this)
      .parents(".variant-input")
      .prevAll(".variant-input")
      .each(function (index) {
        if (index < 1) {
          var get = $(this).find("label").hasClass("disabled-new");
          if (get == true) {
            $(this)
              .parents(".variant-wrapper")
              .find(".get-it-tailored-button")
              .show();
            //$(this).parents(".variant-wrapper").find(".selected-text").show();
          } else {
            $(this)
              .parents(".variant-wrapper")
              .find(".get-it-tailored-button")
              .hide();
            $(this)
              .parents(".variant-wrapper")
              .find(".modaltailored .custom-option-variant")
              .html("");
            $(this).parents(".variant-wrapper").find(".selected-text").hide();
          }
          if ($(this).find("label").hasClass("disabled-new")) {
            $(".popup-size-option-items").append(
              "<div class='custom-option-variant'><input type='radio' id='size-option--" +
                index +
                "' name='size-option' value='" +
                $(this).find("label").text() +
                "'><label for='size-option--" +
                index +
                "'>" +
                $(this).find("label").text() +
                "</label></div>"
            );
          }
        }
      });
    var Selectedval = $("select.product-single__variants option:selected").attr(
      "variant-id"
    );
    // $(".popup-length-options").hide();
    // $(".popup-size-options").show();
    countPrice.push(
      $("select.product-single__variants")
        .find("option:selected")
        .attr("variant-money")
    );
    $(".popup-options-container").each(function () {
      if ($(this).find("input").is(":checked")) {
        countPrice.push(
          $(this).find(".options-container").attr("tailored-price")
        );
      }
    });
    console.log(countPrice);
    var total = 0;
    countPrice.forEach(function (num) {
      total += parseFloat(num) || 0;
    });
    console.log(total);
    total = parseFloat(total) / 100;
    var newTotal = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    console.log(newTotal);
    var newCurrency = currencyFormat
      .replace("{{amount}}", newTotal)
      .replace("{{amount_with_comma_separator}}", newTotal)
      .replace("{{amount_no_decimals_with_comma_separator}}", newTotal)
      .replace("{{amount_no_decimals}}", newTotal)
      .replace("{{amount_no_decimals_with_space_separator}}", newTotal);
    console.log(newCurrency);
    $("span.product__price").text(newCurrency);
    //$("span.product__price").text(currencyFormat+(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
  });
  $(".get-it-tailored-button").on("click", function () {
    $("[popup-type='" + $(this).attr("tailored-type") + "']").show();
    //$(".modaltailored").show();
  });
  var prices = [];
  var currencyFormat = $("html").attr("currenct-form");
  $("button.proceed-to-cart-btn").on("click", function () {
    var thiss = this;
    prices = [];
    $("[popup-type='" + $(this).attr("button-type") + "']").hide();
    var valSel = $(this)
      .parents(".popup-options-container")
      .find("input:checked")
      .val();
    $(this)
      .parents(".variant-wrapper.js")
      .find(".selected-text")
      .text(
        "We will customize this " +
          $(this).attr("button-type") +
          " to " +
          valSel +
          " according to your specifications"
      );
    $(this).parents(".variant-wrapper.js").find(".selected-text").show();
    prices.push(
      $("select.product-single__variants")
        .find("option:selected")
        .attr("variant-money")
    );
    $(".popup-options-container").each(function () {
      if ($(this).find("input").is(":checked")) {
        prices.push($(this).find(".options-container").attr("tailored-price"));
      }
    });
    var total = 0;
    prices.forEach(function (num) {
      total += parseFloat(num) || 0;
    });
    console.log(total);
    total = parseFloat(total) / 100;
    var newTotal = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    console.log(newTotal);
    var newCurrency = currencyFormat
      .replace("{{amount}}", newTotal)
      .replace("{{amount_with_comma_separator}}", newTotal)
      .replace("{{amount_no_decimals_with_comma_separator}}", newTotal)
      .replace("{{amount_no_decimals}}", newTotal)
      .replace("{{amount_no_decimals_with_space_separator}}", newTotal);
    console.log(newCurrency);
    $("span.product__price").text(newCurrency);
    //$("span.product__price").text(currencyFormat+(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
  });
  $(".close-popup").on("click", function () {
    $(".modaltailored").hide();
  });
  $(document).on("change", ".popup-options-container input", function () {
    $(this)
      .parents(".popup-options-container")
      .find("button")
      .removeAttr("disabled");
    $("button.btn.btn--full.add-to-cart").addClass("final-add-to-cart");
  });
  //Add to Cart
  var ids = [];
  var selected_option = [];
  $(".body-template-product-custom-tailored button.add-to-cart").on(
    "click",
    function (e) {
      $(
        ".body-template-product-custom-tailored button.btn.btn--full.add-to-cart"
      ).addClass("btn--loading");
      e.preventDefault();
      e.stopPropagation();
      var ptitle = $("h1.h2.product-single__title").text();
      ptitle = ptitle.replace("&", "and");
      ptitle = "'" + ptitle + "'";
      var qty = $(".product__quantity .js-qty__wrapper input").val();

      var unique__ID = Math.floor(Math.random() * 10000000);
      selected_option = [];
      $(this).parents(".modaltailored").hide();
      ids = [];
      ids.push(
        $("select.product-single__variants").find("option:selected").val()
      );
      $(".options-container").each(function () {
        var getChecked = $(this).find("input[type='radio']:checked").val();
        if (getChecked != "" && getChecked != undefined) {
          var getId = $(this).find(".additional-variant-id").val();
          ids.push(getId);
          //selected_option.push($(this).find("label.variant__label").text() +"="+ $(this).find("input[type='radio']:checked").val());
          selected_option.push(
            $(this).find("input[type='radio']:checked").val()
          );
        }
      });
      setTimeout(function () {
        for (var i = 0; i < ids.length; i++) {
          if (ids.length > 1) {
            if (i == 0) {
              console.log(i);
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: false,
                data:
                  "quantity=" +
                  qty +
                  "&id=" +
                  ids[i] +
                  "&properties[Selected Tailored Options]=" +
                  selected_option.join("/") +
                  "&properties[_Unique_ID]=" +
                  unique__ID +
                  "&properties[_Parent_Product]=True",
                dataType: "json",
                success: function (response) {
                  console.log("added to cart");
                  console.log(response);
                },
              });
            } else {
              console.log(i);
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: false,
                data:
                  "quantity=" +
                  qty +
                  "&id=" +
                  ids[i] +
                  "&properties[Selected Tailored Options]=" +
                  selected_option +
                  "&properties[_Unique_ID]=" +
                  unique__ID +
                  "&properties[_Child_Product]=True&properties[For_product]=" +
                  ptitle,
                dataType: "json",
                success: function (response) {
                  console.log("added to cart");
                  console.log(response);
                },
              });
            }
          } else {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              async: false,
              data: "quantity=" + qty + "&id=" + ids[i],
              dataType: "json",
              success: function (response) {
                console.log("added to cart");
                console.log(response);
              },
            });
          }
        }
        document.addEventListener("ajaxProduct:added", function (evt) {
          console.log(evt.detail.product);
        });
        //$(".options-container .custom-option-variant").html("");
        document.dispatchEvent(new CustomEvent("cart:build"));
        $(
          ".body-template-product-custom-tailored button.btn.btn--full.add-to-cart"
        ).removeClass("btn--loading");
        console.log(dra);
        dra.open();
      }, 500);
    }
  );
  //select first available option
  if (
    $(
      ".body-template-product-custom-tailored fieldset[data-index='option1'] .variant-input"
    )
      .find("input:checked")
      .siblings("label")
      .hasClass("disabled-new")
  ) {
    $(
      ".body-template-product-custom-tailored fieldset[data-index='option1'] .variant-input"
    )
      .find("input:checked")
      .parents(".variant-input")
      .next(".variant-input")
      .each(function (index) {
        if ($(this).find("label").hasClass("disabled-new")) {
        } else {
          $(this).find("input").trigger("click");
          if (
            $(
              ".body-template-product-custom-tailored fieldset[data-index='option2'] .variant-input"
            )
              .find("input:checked")
              .siblings("label")
              .hasClass("disabled-new")
          ) {
            //$(this).find("input").prop("checked", false)
            // $(".body-template-product-custom-tailored fieldset[data-index='option2'] .variant-input").find("input:checked").parents(".variant-input").next(".variant-input").each(function(index){
            //   if ( $(this).find("label").hasClass("disabled-new") )
            //   {
            //   }
            //   else
            //   {
            //     $(this).find("input").trigger("click")
            //   }
            // })
            $(
              ".body-template-product-custom-tailored fieldset[data-index='option2']"
            )
              .find(".variant-input:not(.disabled-option)")
              .first()
              .find("input")
              .trigger("click");
          }
          return false;
        }
      });
  }
  $(document).on("click", ".custom-cart-plus", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var getVal = $(this).siblings(".custom-cart-quantity").val();
    var newval = 1;
    newval += parseInt(getVal);
    $(this).siblings("input").val(newval).trigger("change");
    var Url = $(this).parents(".cart__item").attr("cart-remove-url");
    Url = Url.replaceAll("=0", "=" + newval);
    console.log(Url);
  });
  $(document).on("click", ".custom-cart-minus", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var getVal = $(this).siblings(".custom-cart-quantity").val();
    var newval = 1;
    if (getVal >= 1) {
      newval = parseInt(getVal) - parseInt(newval);
      $(this).siblings("input").val(newval).trigger("change");
      var Url = $(this).parents(".cart__item").attr("cart-remove-url");
      Url = Url.replaceAll("=0", "=" + newval);
      console.log(Url);
    }
  });
  $(document).on("change", ".custom-cart-quantity", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var Url = $(this).parents(".cart__item").attr("cart-remove-url");
    Url = Url.replaceAll("=0", "=" + $(this).val());
    console.log(Url);
    $.ajax({
      type: "POST",
      url: Url,
      dataType: "json",
      async: false,
      success: function (data) {
        console.log(data);
        // document.addEventListener('ajaxProduct:added', function(evt) {
        //   console.log(evt.detail.product);
        // });
        document.dispatchEvent(new CustomEvent("cart:build"));
      },
    });
  });
  $(".body-template-product-custom-tailored .variant-wrapper.js").each(
    function () {
      var selectedOption = $(this).find("input:checked");
      console.log(selectedOption);
      $(this).find("input:checked").addClass("will-check");
      $(this).find("input:checked").prop("checked", false);
      //$(this).find("input.will-check").prop("checked", true);
      $(this).find("input.will-check").trigger("click");
    }
  );
});
